/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {



})();
function apriPopup() {
    window.open("https://www.kult.com.cy/pages/shipping", "Popup", "width=500,height=500");
  }


